import { coreEnvironments } from './core';
import { voidEnvironments } from './void';

export type { Environment, EnvironmentFeature } from './types';
export const environments = [...coreEnvironments, ...voidEnvironments];
